export default "__VITE_ASSET__t$IXQNms__"